import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../services/constants";
import { showToastNotification } from "../reducers/toastSlice";
import { setSpaceUserDetails } from "../reducers/projectUsers";
import { t, untranslated } from "@i18n";
import type { AddUserToSpaceResponse, DeleteUserFromSpaceResponse } from "@ServerTypes/spaces/space.schema";
import type { AddUserToProjectResponse } from "@ServerTypes/projects/project.schema";
import type { GetAllUsersInSpaceResponse } from "@ServerTypes/accounts/accounts.schema";

export function addUserToSpace(data, metadata, refreshHandler, updatePermission) {
  return (dispatch: AppDispatch) => {
    axiosWrapper.post<AddUserToSpaceResponse>(`${getBackendUrl()}/spaces/addUserToSpace`, data).then((response) => {
      metadata
        ? dispatch(
            showToastNotification({
              content: t("{{user}} added to Space {{space}} successfully!", {
                user: metadata.selectedAddUserName,
                space: metadata.spaceName,
              }),
              type: TOAST_TYPE_SUCCESS,
            }),
          )
        : null;
      if (updatePermission && response.data.status) {
        dispatch(
          showToastNotification({
            content: t("Permission changed successfully!"),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      } else if (!response.data.status) {
        dispatch(
          showToastNotification({
            content: untranslated(response.data.errorMessage),
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
      if (refreshHandler) {
        refreshHandler();
      }
    });
  };
}
export const DeleteUserFromSpace = async (data) => {
  const response = await axiosWrapper.post<DeleteUserFromSpaceResponse>(
    `${getBackendUrl()}/spaces/DeleteUserFromSpace`,
    data,
  );
  return response;
};

export async function addUserToProject(data) {
  const responseData = await axiosWrapper.post<AddUserToProjectResponse>(
    `${getBackendUrl()}/projects/addUserToProject`,
    data,
  );
  return responseData;
}

export function getAllUsersInSpace(data) {
  return async (dispatch: AppDispatch) => {
    await axiosWrapper
      .post<GetAllUsersInSpaceResponse>(`${getBackendUrl()}/accounts/getAllUsersInSpace`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(setSpaceUserDetails(response.data.result ?? []));
        }
      });
  };
}
